import { TReportFilter } from "../../api/types/Report";
import { APP_CONFIG } from "../../constants/constants";

// ensures that only specific fields are sent to BE for creating/updating custom reports
// and extra/pseudo fields created for reportOptions are filtered out
export const filterReportFiltersCallback = (
  key: string,
  report_filters: TReportFilter[]
) => {
  return report_filters.filter((field) => field.param === key).length > 0;
};

// check if report filter has multi-select applicable
export const filterIsMultiSelect = (
  fieldParam: string,
  reportFilters: TReportFilter[]
) => {
  return fieldParam ===
    APP_CONFIG.REPORTS.BASIC_DROPDOWN_FILTERS.DEVICE.field_name
    ? // if field param is device_id, then check if device_groups is also present as a filter
      !!reportFilters?.find(
        (item) =>
          item.param ===
          APP_CONFIG.REPORTS.BASIC_DROPDOWN_FILTERS.GROUP.field_name
      )
    : (fieldParam === APP_CONFIG.REPORTS.BASIC_DROPDOWN_FILTERS.GEOZONE.field_name)?
    !!reportFilters?.find(
      (item) =>
        item.param ===
        APP_CONFIG.REPORTS.BASIC_DROPDOWN_FILTERS.GEOZONE.field_name
    )?.is_multiple_allowed
    :
    // for other fields, check if the field config has multiple set to true
      !!Object.values(APP_CONFIG.REPORTS.BASIC_DROPDOWN_FILTERS).find(
        (value, _) => value.field_name === fieldParam
      )?.multiple;
};
